export default "__VITE_ASSET__BuchV9gK__"